import { jsx as l } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { c as m } from "./cn-DlLpp5ix.js";
const f = {
  text: "var(--radius-sm)",
  rect: "var(--radius-md)",
  circle: "var(--radius-full)"
}, p = a(function({ variant: e = "text", width: t, height: o, className: i, style: s, ...c }, d) {
  const r = o ?? (e === "text" ? 12 : e === "circle" ? t ?? 32 : 80), n = {
    display: "inline-block",
    width: t ?? (e === "circle" ? r : "100%"),
    height: r,
    borderRadius: f[e],
    ...s
  };
  return /* @__PURE__ */ l(
    "span",
    {
      ref: d,
      "data-ls-component": "skeleton",
      "data-variant": e,
      "aria-hidden": "true",
      className: m(i),
      style: n,
      ...c
    }
  );
});
p.displayName = "Skeleton";
export {
  p as S
};
//# sourceMappingURL=Skeleton-BOboktJd.js.map
